import {Component, computed, inject, OnInit, signal, WritableSignal} from '@angular/core';
import {CompanyService} from '@services/company.service';
import {ICompanyDetailsSimplified} from '@models/company.interface';
import {ContentHeader} from '@shared/components/content-header/content-header';
import {Router} from '@angular/router';
import {UserStateService} from '@services/frontend/user-state.service';
import {Role} from '@models/user.interface';
import {ExecutiveSubscriptionState} from '@services/executive-subscription.state';

@Component({
  selector: 'app-company-list',
  imports: [ContentHeader],
  templateUrl: './company-list.html'
})
export class CompanyList implements OnInit {

  private companyService = inject(CompanyService);
  private router = inject(Router);
  private userStateService = inject(UserStateService);
  private executiveSubscriptionState = inject(ExecutiveSubscriptionState);

  companies: WritableSignal<ICompanyDetailsSimplified[]> = signal([]);

  userGreeting = computed(() => {
    const fullName = this.userStateService.getUser()()?.fullName?.trim() ?? '';
    const parts = fullName.split(/\s+/).filter(Boolean);
    if (parts.length >= 2) {
      return {firstName: parts[0], lastName: parts.slice(1).join(' ')};
    }
    return {firstName: fullName, lastName: ''};
  });

  showWelcome = computed(() =>
    this.userStateService.getUser()()?.role === Role.EXECUTIVE
    && this.executiveSubscriptionState.isFreeExecutive()
    && this.companies().length === 0
  );

  ngOnInit() {
    this.executiveSubscriptionState.ensureLoaded();

    if (this.userStateService.getUser()()?.role === Role.ACCOUNTANT) {
      void this.router.navigate(['/dashboard', 'expert', 'clients']);
      return;
    }
    this.init();
  }

  init() {
    this.companyService.getCompanies()
      .subscribe(companies => this.companies.set(companies));
  }
}
